module.exports = __webpack_public_path__ + "img/insurance-logo-13.ed94eacb.png";